import { TimeIcon } from '@braskai/icons';
import { Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { PlanCategory } from '@/shared/types/Billing';

export type MinutesTextProps = {
  category: PlanCategory;
  value: number | string;
};

export const MinutesText = ({ category, value }: MinutesTextProps) => {
  const isEnterprise = category === PlanCategory.Enterprise;

  let label: number | string = value;
  if (isEnterprise) {
    label = 'Custom minutes';
  } else if (typeof value === 'number') {
    label = `${value.toLocaleString('en-US')} minutes included`;
  }

  const contentColor = isEnterprise ? 'primary.900' : 'common.black';

  return (
    <Stack
      sx={{
        backgroundColor: isEnterprise ? 'primary.200' : 'grey.50',
        borderRadius: 8,
        color: contentColor,
        paddingX: 16,
        paddingY: 12,
        width: '100%',
      }}
      alignItems="center"
      direction="row"
      gap={8}
      justifyContent="center"
    >
      <TimeIcon height={20} width={20} />
      <Typography color={contentColor} variant="body-2-md">
        {label}
      </Typography>
    </Stack>
  );
};
